import {
  Link,
  Wrapper,
  ConnectionView,
  Icon,
  Inserter,
  Image,
} from "nystem-components";
import { useState, useEffect } from "react";

const PartMenu = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const close = () => {
      if (open === true) setOpen(false);
    };
    setTimeout(() => {
      window.addEventListener("click", close);
    }, 0);
    return () => {
      window.removeEventListener("click", close);
    };
  }, [open]);

  return (
    <Wrapper
      renderAs="header"
      className="bg-menu py-1 w-full pl-3 pr-2 md:mx-0 print-hidden bg-hepard-light-gray -mb-10"
    >
      <Wrapper
        renderAs="nav"
        className="flex container m-auto justify-center items-center"
      >
        <Link to="/" exact="true">
          <ConnectionView>
            <Image
              className="m-3 w-22 min-w-22 md:min-w-40"
              src="/image/200x200/logo.jpg"
              width="100"
              alt="logo"
            />
          </ConnectionView>
          <ConnectionView offline="true">
            <Image
              src="/image/200x200/logo.jpg"
              width="100"
              className="m-3 w-22 grayscale min-w-22 md:min-w-40"
              alt="logo"
            />
          </ConnectionView>
        </Link>
        <Wrapper className="flex-grow" />
        <Inserter
          match="*"
          className="mr-6 font-bold overflow-hidden text-nowrap flex"
          source="/menu/view/main"
        />
        <Icon
          icon="bars"
          title="Menu"
          className="shadow mx-1 rounded bg-white/30 p-1 min-w-10 h-10 cursor-pointer md:hidden"
          onClick={() => setOpen(!open)}
        />
        <Wrapper className="relative w-1">
          {open ? (
            <Wrapper className="absolute w-64 mt-6 right-0 text-lg shadow mx-1 rounded bg-white/95 p-1">
              <Inserter
                match="*"
                className="font-bold "
                source="/menu/view/main"
              />
            </Wrapper>
          ) : null}
        </Wrapper>
      </Wrapper>
    </Wrapper>
  );
};
export default PartMenu;
